import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@cnx-saas/react-auth';
import { Loading } from '@cnx-saas/common-fe';
import { availableRoutes } from '../routes/available-routes';

interface Props {
  element: JSX.Element;
}

const ProtectedRoute = ({ element }: Props) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.initialized) {
    return <Loading></Loading>;
  }

  return auth.authenticated ? (
    element
  ) : (
    <Navigate to={availableRoutes.login} state={{ referrer: location }} />
  );
};

export { ProtectedRoute };
